import { FolderOpen } from 'lucide-react';

/**
 * Platzhalter für das kommende Dokumente-Modul (pro Bauvorhaben strukturierte
 * Dokumentenablage als Ersatz für die Netzwerk-Ordnerstruktur). Erscheint nur,
 * wenn ein Admin das Modul aktiviert hat — bis dahin ist es global aus.
 */
export function DokumentePage() {
  return (
    <div className="max-w-2xl mx-auto">
      <div className="card p-8 text-center">
        <div className="mx-auto w-12 h-12 rounded-full bg-primary-50 flex items-center justify-center mb-4">
          <FolderOpen className="h-6 w-6 text-primary-600" />
        </div>
        <h1 className="text-xl font-semibold text-gray-900 mb-2">Dokumente</h1>
        <p className="text-gray-600">
          Dieses Modul befindet sich in Entwicklung und steht in Kürze zur Verfügung.
        </p>
      </div>
    </div>
  );
}